import type { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

/** How far along a step is: cleared, the furthest one reached, or not reachable until earlier gates are cleared. */
export type StepProgress = 'done' | 'latest' | 'locked';

function getProgressColor(theme: Theme, progress: StepProgress) {
  if (progress === 'done') {
    return theme.palette.success.main;
  }

  return progress === 'latest' ? theme.palette.primary.main : theme.palette.text.disabled;
}

/**
 * Colour shows progress only (green done, solid blue latest reached, grey locked); the current step keeps
 * its colour and adds a soft halo of it.
 */
export function getStepIconSx({ isCurrent, progress }: { isCurrent: boolean; progress: StepProgress }): SxProps<Theme> {
  return (theme) => {
    const color = getProgressColor(theme, progress);

    return {
      // MUI paints the active step primary blue via `.Mui-active`, so that state needs overriding too.
      '& .MuiStepIcon-root, & .MuiStepIcon-root.Mui-active': { color },
      ...(isCurrent && {
        '& .MuiStepIcon-root': { borderRadius: '50%', boxShadow: `0 0 0 4px ${alpha(color, 0.3)}` },
      }),
    };
  };
}
